import { render, staticRenderFns } from "./AllocationOnlineGroupList.vue?vue&type=template&id=110eaa03&"
import script from "./AllocationOnlineGroupList.vue?vue&type=script&lang=js&"
export * from "./AllocationOnlineGroupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports